/** TIF TN kodi nomenklaturadagi yozilishda: 852589 -> "8525 89", 8529 -> "8529". */
export function fmtCode(code = "") {
  const parts = [code.slice(0, 4)];
  for (let i = 4; i < code.length; i += 2) parts.push(code.slice(i, i + 2));
  return parts.join(" ");
}

/** Qism qutisini biroz kengaytiradi (0-1000): kesilgan rasmda qism chetlari qirqilmasin. */
export function padBox([y0, x0, y1, x1], k = 30) {
  return [Math.max(0, y0 - k), Math.max(0, x0 - k), Math.min(1000, y1 + k), Math.min(1000, x1 + k)];
}

/** Katta ko'rinish uchun kadrlar: rasmda topilgan qismlar va jarayon bosqichlari. */
export const partFrames = (parts = []) =>
  parts.filter((p) => p.box).map((p) => ({
    key: p.n,
    box: padBox(p.box),
    title: `${p.n}. ${p.name}`,
    sub: [p.material, p.codes?.[0] && fmtCode(p.codes[0].code)].filter(Boolean).join(" · "),
  }));

export const processFrames = (steps = []) =>
  steps.filter((s) => s.box).map((s) => ({ key: s.n, box: s.box, title: `${s.n}. ${s.name}` }));
